// Static manifest of help-centre articles. Files live in public/help/ and are
// fetched at runtime rather than bundled, so updating an article is just
// editing the .md file — no rebuild needed for content-only changes.
// `slug` must match each file's own frontmatter `slug:` field.
const HELP_ARTICLES = [
  { file: '01-getting-started.md', slug: 'getting-started' },
  { file: '02-gig-management.md', slug: 'gig-management' },
  { file: '03-live-requests.md', slug: 'live-requests' },
  { file: '04-song-library.md', slug: 'song-library' },
  { file: '05-set-list-builder.md', slug: 'set-list-builder' },
  { file: '06-analytics.md', slug: 'analytics' },
  { file: '07-branding-settings.md', slug: 'branding-settings' },
  { file: '08-tech-rider.md', slug: 'tech-rider' },
  { file: '09-public-page.md', slug: 'public-page' },
  { file: '10-audience-requests.md', slug: 'audience-requests' },
];

export const TIER_LABELS = { starter: 'Starter', pro: 'Pro', band: 'Band' };
export const TIER_COLORS = { starter: '#6c757d', pro: '#667eea', band: '#764ba2' };

export default HELP_ARTICLES;
